import { Link } from 'react-router-dom';
import { ARTICLES } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function FeaturedArticles() {
  const lead = ARTICLES[1];
  const rest = ARTICLES.slice(2, 6);

  return (
    <section className="w-full bg-background-100 border-y border-background-200 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="RECENT DIGS"
          title="最近挖出来的一批"
          description="每篇档案都附上材料来源、复原程度与存疑说明。与其说是文章，不如说是一份公开的考据笔记。"
          action={
            <Link
              to="/archive"
              className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              进入档案库
              <i className="ri-arrow-right-line"></i>
            </Link>
          }
        />

        <div className="mt-10 md:mt-14">
          <ArticleCard article={lead} variant="wide" />
        </div>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {rest.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}